import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useIsSubscriber = () => {
	const { userTags } = useUserTags();

	return userTags.includes(tags.subscriber);
};
